import React from 'react';
import styled from '@emotion/styled';
import { GrammarDescriptionFlagWrapper } from '@seedlang/hoc';
import Modal from 'components/modal';
import Button from 'components/button/button';

const FlagButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 12px 0 0 auto;
  padding: 6px 10px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #888;
  font: inherit;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.15s ease;
  &:hover, &:focus-visible { background: #F1F1F1; }
  &:active { background: #E5E5E5; }
`;

const GrammarDescriptionFlag = props => <>
  <FlagButton type='button' onClick={props.onOpen}>
    <i className='fa fa-flag' aria-hidden='true' />
    Flag Issue
  </FlagButton>
  {props.open && <Modal gradient title='Report Issue' width='min(500px, 90vw)' onCloseModal={props.onClose}>
    {props.submitted ? <div style={{ padding: 20 }} role='status'>
      <p>Thanks for letting us know! Your report has been sent.</p>
      <Button onClick={props.onClose}>Done</Button>
    </div> : <form style={{ padding: 20 }} onSubmit={event => { event.preventDefault(); props.onSubmit(); }}>
      <label dir="auto">
        {props.questionText}
        <textarea autoFocus required maxLength={2000} rows={6} value={props.feedback}
          onChange={event => props.onChange(event.target.value)} disabled={props.submitting}
          style={{ width: '100%', margin: '15px 0', padding: 10, font: 'inherit', fontWeight: 'normal' }} />
      </label>
      {props.error && <p role='alert'>{props.error}</p>}
      <Button onClick={props.onSubmit} disabled={props.submitting || !props.feedback.trim()}>
        {props.submitting ? 'Sending…' : 'Submit'}
      </Button>
    </form>}
  </Modal>}
</>;

export default GrammarDescriptionFlagWrapper(GrammarDescriptionFlag);
